import { TextSpan } from '../../../Atoms/Text';
import { TextButton } from '../../../Atoms/TextButton';
import { CountLineItemsButton } from './CountLineItemsButton';
import { ManualSpendDraft } from './useManualSpendDraft';

export interface ManualEntrySwitchProps {
  draft: ManualSpendDraft;
  countLinesSupplierId?: string;
}

export const ManualEntrySwitch = ({ draft, countLinesSupplierId }: ManualEntrySwitchProps) => {
  if (draft.entry === 'monthly_total' && countLinesSupplierId) {
    return (
      <CountLineItemsButton
        supplierId={countLinesSupplierId}
        disabled={draft.saving}
      />
    );
  }
  if (draft.entry === 'monthly_total') {
    return (
      <TextButton
        className="self-start"
        disabled={draft.saving}
        onClick={() => draft.setEntry('line_items')}>
        enter line items instead
      </TextButton>
    );
  }
  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        className="rounded-lg border border-dashed border-grey-3 px-4 py-2 enabled:hover:bg-grey-1 disabled:opacity-50"
        disabled={draft.saving}
        onClick={draft.addLine}>
        <TextSpan
          size="sm"
          color="indigoCTA">
          + Add Line Item
        </TextSpan>
      </button>
      <TextSpan
        size="sm"
        color="grey6">
        or
      </TextSpan>
      <TextButton
        disabled={draft.saving}
        onClick={() => draft.setEntry('monthly_total')}>
        enter a single monthly total instead
      </TextButton>
    </div>
  );
};
